import { Alert } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

function LinkHeader(props) {
  const { title, code, name, link, visible, type } = props
  return visible ? (
    <Alert
      type={'success'}
      description={
        <span>
          {code && (
            <span>
              <strong>{type} Code</strong> : [{code}]
            </span>
          )}{' '}
          {name && (
            <span>
              <strong> Name</strong>: {name}.
            </span>
          )}
          <Link to={link}> Click here </Link>to navigate to It.
        </span>
      }
      message={
        <span>
          This <strong>{title}</strong> is Part of a {type}.
        </span>
      }
    />
  ) : (
    <span />
  )
}

LinkHeader.defaultProps = {
  type: 'Enquiry',
  visible: true,
}

export default LinkHeader
